import React from 'react'
import './footer.css'

export default function Footer({ ...rest }) {
    return <footer className={'footer'} {...rest} />
}
